// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipZIndex":"3","tooltipSpacing":"10px","button":"VgXi5XtLxzyo","facebookText":"nSp5t0SqVMQS","logo":"nIlJpgEhFR96"};